import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import BinanceBalance from "../components/BinanceBalance";

const BlankPagePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Binace Balance' />

        {/* BlankPageLayer */}
        <BinanceBalance />
      </MasterLayout>
    </>
  );
};

export default BlankPagePage;
